import { Locale } from "@/types/auth";

export type MessageKey =
  | "brand"
  | "home"
  | "about"
  | "initiatives"
  | "termsAndConditions"
  | "privacyPolicy"
  | "login"
  | "startNow"
  | "heroTitle"
  | "heroSubtitle"
  | "whoAreYou"
  | "selectRole"
  | "merchant"
  | "initiativeEntity"
  | "continueAsMerchant"
  | "continueAsInitiative"
  | "welcomeBack"
  | "email"
  | "password"
  | "forgotPassword"
  | "invalidEmail"
  | "requiredField"
  | "logout"
  | "loginFailed"
  | "navOverview"
  | "navPrograms"
  | "navSettings"
  | "navNotifications"
  | "quickActionsTitle"
  | "quickActionsSubtitle"
  | "quickActionsCreateInitiative"
  | "quickActionsViewApprovals"
  | "quickActionsInviteMember"
  | "sidebarNavigation"
  | "sidebarBadgeLabel"
  | "sidebarCollapse"
  | "sidebarExpand"
  | "sidebarCloseDrawer"
  // Wallet Dashboard
  | "walletBalance"
  | "nationalCurrency"
  | "greenPoints"
  | "smartPoints"
  | "communityPoints"
  | "financialOverview"
  | "balanceOverview"
  | "totalBalance"
  | "totalEarnings"
  | "totalSpendings"
  | "netBalance"
  | "transactionHistory"
  | "transactions"
  | "amount"
  | "type"
  | "status"
  | "date"
  | "initiative"
  | "viewDetails"
  // Transaction Status
  | "pending"
  | "completed"
  | "failed"
  | "inbound"
  | "outbound"
  | "transactionId"
  | "direction"
  | "fee"
  | "commission"
  | "settled"
  | "yes"
  | "no"
  | "initiativeType"
  | "actions"
  // Initiative Statuses
  | "statusActive"
  | "statusInactive"
  | "statusDraft"
  | "statusIncoming"
  | "statusFunded"
  | "statusPublished"
  | "statusPaused"
  | "statusPendingApproval"
  | "statusCompleted"
  | "statusExpired"
  | "statusPending"
  | "statusCancelled"
  // Initiative Types
  | "typeWalk"
  | "typeJuthoor"
  // Initiative Actions
  | "setBudget"
  | "setBudgetAction"
  // Financial Breakdowns
  | "dailyBreakdown"
  | "weeklyBreakdown"
  | "monthlyBreakdown"
  | "spendingDistribution"
  | "earnings"
  | "spendings"
  // Initiative Statistics
  | "initiativeStats"
  | "totalInitiatives"
  | "activeInitiatives"
  | "participantsRewarded"
  | "participants"
  | "totalEnablers"
  | "communitiesReached"
  | "participationGrowth"
  | "budgetUsage"
  | "budgetUsed"
  | "budgetRemaining"
  | "usagePercentage"
  // Time Periods
  | "daily"
  | "weekly"
  | "monthly"
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday"
  | "week1"
  | "week2"
  | "week3"
  | "week4"
  | "week5"
  // Months
  | "jan"
  | "feb"
  | "mar"
  | "apr"
  | "may"
  | "jun"
  | "jul"
  | "aug"
  | "sep"
  | "oct"
  | "nov"
  | "dec"
  // UI States
  | "loading"
  | "loadingData"
  | "error"
  | "errorLoadingData"
  | "retry"
  | "retryLoading"
  | "noData"
  | "noDataAvailable"
  | "noTransactions"
  | "noTransactionsMessage"
  | "noInitiatives"
  | "noInitiativesMessage"
  // Filters
  | "filter"
  | "filterBy"
  | "search"
  | "searchPlaceholder"
  | "category"
  | "all"
  | "community"
  | "green"
  | "unknown"
  // Initiative fields
  | "title"
  | "budget"
  | "description"
  | "startDate"
  | "endDate"
  | "enablers"
  // Initiative status
  | "draft"
  | "published"
  | "active"
  | "paused"
  | "cancelled"
  // Pagination
  | "page"
  | "of"
  | "previous"
  | "next"
  | "showing"
  | "results"
  // Create Initiative Wizard
  | "createInitiative"
  | "newInitiative"
  | "selectTemplate"
  | "templateCategory"
  | "configureRewards"
  | "stepSelectInitiative"
  | "stepConfigureRewards"
  | "comingSoon"
  | "initiativeTitle"
  | "initiativeTitleEn"
  | "initiativeScope"
  | "scopeCooperative"
  | "scopeIndividual"
  | "scopeInstitutional"
  | "participationLimit"
  | "unlimited"
  | "custom"
  | "cityField"
  | "communityField"
  | "communities"
  | "communitiesOptional"
  | "chooseOption"
  | "templateSocial"
  | "templateCommunity"
  | "templateEnvironmental"
  // Wizard Step 2 — Rewards
  | "initiativeDuration"
  | "fixedDuration"
  | "openDuration"
  | "durationOneMonth"
  | "durationSixMonths"
  | "durationOneYear"
  | "customDuration"
  | "impactStructure"
  | "impactStructureSubtitle"
  | "targetGoal"
  | "goalTimeDays"
  | "rewardOnCompletion"
  | "conversionRate"
  | "aiRateHint"
  | "getAiRecommendation"
  | "budgetEstimator"
  | "estimateByUsers"
  | "estimateByBudget"
  | "expectedParticipants"
  | "rewardGivenEvery"
  | "rewardsPerPeriod"
  | "initiativeDurationLabel"
  | "rewardPeriodsCount"
  | "estimatedBudgetRequired"
  | "estimatedBudgetSar"
  | "budgetEstimatorNote"
  | "budgetAmount"
  | "maxParticipants"
  // Action modals
  | "fundInitiative"
  | "fundInitiativeWarning"
  | "walletBalance"
  | "confirmFund"
  | "inviteParticipant"
  | "shareImpact"
  | "shareImpactTagline"
  | "whoToInvite"
  | "inviteIdentifierPlaceholder"
  | "requestJoin"
  | "existingEnabler"
  | "inviteByEmail"
  | "selectEnabler"
  | "noEnablersAvailable"
  | "reactivateInitiative"
  | "setOpenEnded"
  | "usePreviousSettings"
  | "usePreviousSettingsNote"
  // Initiative Details
  | "initiativeDetails"
  | "infoTab"
  | "statisticsTab"
  | "shareInitiative"
  | "createReport"
  | "cancelAction"
  | "backToInitiatives"
  | "inviteSentSuccess"
  | "initiativeType"
  | "locationScope"
  | "timeline"
  | "goalStructure"
  | "mainGoal"
  | "pointsPerGoal"
  | "conversionRateLabel"
  | "partnerOrganisations"
  | "fundsCollected"
  | "avgGrowth"
  | "millionsImpact"
  | "participationOverTime"
  | "genderDistribution"
  | "joinedStores"
  | "businessCategories"
  | "localLeaders"
  | "noCategoriesData"
  | "noCategoriesMessage"
  | "noLeadersYet"
  | "noLeadersMessage"
  | "female"
  | "male"
  | "allStores"
  | "storesViaLink"
  | "expired"
  // Settings Page
  | "settingsTitle"
  | "profileSettings"
  | "orgName"
  | "orgDescription"
  | "sector"
  | "orgEmail"
  | "websiteField"
  | "saveChanges"
  | "notificationPreferences"
  | "newInitiativesNotif"
  | "contributionRequestsNotif"
  | "initiativeUpdatesNotif"
  | "newInitiativesNotifDesc"
  | "contributionRequestsNotifDesc"
  | "initiativeUpdatesNotifDesc"
  | "languagePreferences"
  | "arabicLang"
  | "englishLang"
  | "changePassword"
  | "currentPassword"
  | "newPassword"
  | "confirmPassword"
  | "changePasswordBtn"
  | "passwordChanged"
  | "profileUpdated"
  | "avatarUploaded"
  | "sectorCharity"
  | "sectorGovernment"
  | "sectorPrivate"
  | "selectSector"
  | "partnerLogo"
  | "fileTooLarge"
  | "enterCurrentPassword"
  | "enterNewPassword"
  | "reenterNewPassword"
  | "passwordMinLength"
  | "passwordMismatch"
  // Contributions Page
  | "contributionsTitle"
  | "contributionRequests"
  | "myContributions"
  | "trackRequests"
  | "trackContributions"
  | "searchByName"
  | "selectStatusFilter"
  | "receivedDir"
  | "sentDir"
  | "requestDate"
  | "requestedBy"
  | "acceptAction"
  | "rejectAction"
  | "creationDate"
  | "fundedBudget"
  | "noContributionRequests"
  | "noContributionRequestsDesc"
  | "noContributions"
  | "noContributionsDesc"
  | "showMore"
  | "statusAccepted"
  | "statusRejected"
  // Password Reset
  | "forgotPasswordTitle"
  | "forgotPasswordDesc"
  | "sendOtp"
  | "otpSent"
  | "backToLogin"
  | "verifyOtpTitle"
  | "verifyOtpDesc"
  | "otpLabel"
  | "otpPlaceholder"
  | "resendOtp"
  | "resendOtpCooldown"
  | "verifyOtp"
  | "resetPasswordTitle"
  | "resetPasswordDesc"
  | "newPasswordLabel"
  | "confirmPasswordLabel"
  | "resetPasswordBtn"
  | "passwordResetSuccess"
  // Notifications
  | "close"
  | "notificationsTitle"
  | "markAllRead"
  | "noNotifications"
  | "noNotificationsDesc"
  | "notificationUnread"
  // Initiatives Extra
  | "editInitiative"
  | "deleteInitiative"
  | "deleteInitiativeConfirmTitle"
  | "deleteInitiativeConfirmMsg"
  | "joinInitiative"
  | "joinBudgetLabel"
  | "joinBudgetPlaceholder"
  | "joinSuccess"
  | "openInitiativesTab"
  | "participatedTab"
  | "myInitiativesTab"
  | "incomingTab"
  | "noOpenInitiatives"
  | "noParticipated"
  // Wallet Extra
  | "topUpWallet"
  | "topUpAmount"
  | "topUpMethod"
  | "topUpSuccess"
  // Analytics
  | "walkStatsTitle"
  | "treeStatsTitle"
  | "shopsStatsTitle"
  | "saverStatsTitle"
  | "interestAnalyticsTitle"
  | "totalSteps"
  | "totalDistance"
  | "avgSteps"
  | "avgDistance"
  | "highestSteps"
  | "totalTreesPlanted"
  | "goalTrees"
  | "avgTrees"
  | "totalAmountSpent"
  | "goalAmount"
  | "totalPointsEarned"
  | "totalSavings"
  | "totalRewardsDistributed"
  | "progressPercentage"
  | "totalInterested"
  | "analyticsUnavailable"
  // AI Translation
  | "autoTranslate"
  | "translating"
  | "translationError"
  // Walking Initiative Details
  | "walkingAreaType"
  | "openExploration"
  | "structuredPath"
  | "pathsCount"
  | "totalPathDistance"
  | "locationsCount"
  | "noLocations"
  | "noPaths"
  | "locations"
  | "paths"
  | "segments"
  | "meters"
  | "participantLimit"
  | "goalSteps"
  | "rewardPerGoal"
  | "goalTimeLimit"
  | "months"
  | "noTimeLimit"
  | "rewardHistory"
  | "goalsCompleted"
  | "greenPointsEarned"
  | "progressToNextGoal"
  | "stepsRemaining"
  // Sidebar
  | "navWallet"
  | "navAnalytics"
  | "navContributions"
  | "sidebarFaq"
  | "sidebarHowItWorks"
  | "sidebarTerms"
  // About page
  | "aboutHeroTitle"
  | "aboutHeroSubtitle"
  | "missionTitle"
  | "missionBody"
  | "visionTitle"
  | "visionBody"
  | "valuesTitle"
  | "value1Title"
  | "value1Body"
  | "value2Title"
  | "value2Body"
  | "value3Title"
  | "value3Body"
  | "aboutCtaTitle"
  | "aboutCtaButton"
  // Public initiatives page
  | "publicInitiativesTitle"
  | "publicInitiativesSubtitle"
  | "initiativesComingSoon"
  | "initiativesComingSoonBody"
  | "loginForFullAccess"
  | "loginForFullAccessBody"
  | "viewInitiativeDetails"
  // Initiative account request form
  | "initiativeRequestTitle"
  | "initiativeRequestSubtitle"
  | "fullName"
  | "emailAddress"
  | "companyOrganisation"
  | "phoneNumber"
  | "submitRequest"
  | "requestSentTitle"
  | "requestSentBody"
  | "emailAlreadyUsed"
  | "optional"
  | "entityNameAr"
  | "entityNameEn"
  | "entityType"
  | "entityTypeSelectPlaceholder"
  | "responsiblePerson"
  | "whatsappNumber"
  | "website"
  | "message"
  | "organizationLogo"
  | "uploadLogoText"
  | "acceptedFormats"
  | "agreeToTerms"
  | "agreeToTermsError"
  | "invalidFileType"
  // 012-partner-wallet-ui: Period selector
  | "periodDaily"
  | "periodWeekly"
  | "periodMonthly"
  | "periodCustom"
  | "periodFrom"
  | "periodTo"
  // 012-partner-wallet-ui: Charts
  | "transactionVolume"
  | "pointsEarned"
  | "totalPoints"
  | "settlementRate"
  // 012-partner-wallet-ui: Commission summary
  | "commissionSummary"
  | "totalFeesPaid"
  | "totalCommissionEarned"
  | "commissionRate"
  | "netRevenue"
  // 012-partner-wallet-ui: Top-up history
  | "topUpHistory"
  | "loadMore"
  | "copyId"
  | "copied"
  // 012-partner-wallet-ui: Activity feed
  | "activityFeed"
  | "viewAll"
  // 012-partner-wallet-ui: Initiative impact
  | "initiativeImpact"
  | "totalParticipants"
  | "pointsDistributed"
  // 012-partner-wallet-ui: Quick filter chips
  | "quickFilterAll"
  | "quickFilterInbound"
  | "quickFilterOutbound"
  | "quickFilterSettled"
  | "quickFilterPending"
  | "quickFilterFailed"
  // 012-partner-wallet-ui: CSV export
  | "exportCsv"
  | "exportSelected"
  // 012-partner-wallet-ui: Empty states
  | "noActivityYet"
  // 012-partner-wallet-ui: Top-up modal enhancements
  | "estimatedFee"
  | "feeRate"
  | "confirmTopUp"
  | "topUpSummary"
  | "back"
  | "confirm"
  | "presetAmount"
  // 012-partner-wallet-ui: Top-up pending + SAR display
  | "topUpPending"
  | "sarEquivalent"
  // 016-juthoor-partner-ui: Juthoor statuses
  | "statusPendingMunicipalityApproval"
  | "statusMunicipalityApproved"
  | "statusMunicipalityRejected"
  | "statusPendingAdminApproval"
  | "statusAdminApproved"
  | "statusPlantingInProgress"
  // 016-juthoor-partner-ui: Initiative type
  | "typeJuthoor"
  // 016-juthoor-partner-ui: Wizard
  | "juthoorWizardStepTitle"
  | "totalTrees"
  | "rewardPerTree"
  | "maxTreesPerClient"
  | "selectLand"
  // 016-juthoor-partner-ui: Stats
  | "treesPlanted"
  | "treesRewarded"
  | "treesSold"
  | "treesReserved"
  | "treesAvailable"
  | "totalRewardsCommitted"
  | "rewardsEarned"
  | "plantingProgress"
  // 016-juthoor-partner-ui: Detail sections
  | "participationLedger"
  | "joinedDate"
  | "ecosystemFlow"
  | "activeLand"
  | "sustainableImpact"
  // 016-juthoor-partner-ui: Pricing
  | "purchasePrice"
  | "sellingPrice"
  | "marginPerTree"
  | "atharProfitShare"
  | "municipalityProfitShare"
  | "estimatedRevenue"
  | "totalPurchaseCost"
  // 016-juthoor-partner-ui: Admin actions
  | "pendingApprovals"
  | "profitLedger"
  | "rejectionReason"
  | "editAndResubmit"
  | "submitForApproval"
  | "approveInitiative"
  | "rejectInitiative"
  | "setPricing"
  | "juthoorAdminDashboard"
  | "netzeroPurchasedTrees"
  | "distributedProfit"
  | "pendingProfit"
  | "pricingHistory"
  | "enterRejectionReason"
  | "confirmApproval"
  | "approvalConfirmText"
  | "totalClients"
  | "totalRevenue"
  | "totalProfit"
  | "atharProfit"
  | "municipalityProfit";

export const messages: Record<Locale, Record<MessageKey, string>> = {
  ar: {
    brand: "أثـر",
    home: "الرئيسية",
    about: "عن المنصة",
    initiatives: "المبادرات",
    termsAndConditions: "الشروط والأحكام",
    privacyPolicy: "سياسة الخصوصية",
    login: "تسجيل الدخول",
    startNow: "ابدأ الآن",
    heroTitle: "كن جزءًا من التغيير. عزّز دور المجتمع. وحوّل المشاركة إلى أثر.",
    heroSubtitle:
      "أطلق المبادرات، ادعم المجتمعات، وتابع النتائج الحقيقية ضمن منظومة واحدة.",
    whoAreYou: "من أنت؟",
    selectRole: "اختر صفتك",
    merchant: "تاجـر",
    initiativeEntity: "جهة مبادرة",
    continueAsMerchant: "المتابعة كتاجر",
    continueAsInitiative: "المتابعة كجهة مبادرة",
    welcomeBack: "مرحبًا بعودتك إلى أثر",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    forgotPassword: "نسيت كلمة المرور؟",
    invalidEmail: "صيغة البريد الإلكتروني غير صحيحة",
    requiredField: "هذا الحقل مطلوب",
    logout: "تسجيل الخروج",
    loginFailed: "تعذر تسجيل الدخول. تحقق من البيانات وحاول مجددًا",
    navOverview: "نظرة عامة",
    navPrograms: "البرامج",
    navSettings: "الإعدادات",
    navNotifications: "الإشعارات",
    quickActionsTitle: "الخطوات السريعة",
    quickActionsSubtitle: "ابدأ مهمة جديدة أو تابع آخر التحديثات",
    quickActionsCreateInitiative: "إنشاء مبادرة",
    quickActionsViewApprovals: "عرض الموافقات",
    quickActionsInviteMember: "دعوة عضو",
    sidebarNavigation: "التنقل الجانبي",
    sidebarBadgeLabel: "عنصر غير مكتمل",
    sidebarCollapse: "طي القائمة",
    sidebarExpand: "توسيع القائمة",
    sidebarCloseDrawer: "إغلاق القائمة",
    // Wallet Dashboard
    walletBalance: "رصيد المحفظة",
    nationalCurrency: "NC",
    greenPoints: "نقاط خضراء",
    smartPoints: "نقاط اجتماعية",
    communityPoints: "نقاط مجتمع",
    financialOverview: "نظرة عامة مالية",
    balanceOverview: "نظرة عامة على الرصيد",
    totalBalance: "الرصيد الإجمالي",
    totalEarnings: "إجمالي الإيرادات",
    totalSpendings: "إجمالي المصروفات",
    netBalance: "صافي الرصيد",
    transactionHistory: "سجل المعاملات",
    transactions: "المعاملات",
    amount: "المبلغ",
    type: "النوع",
    status: "الحالة",
    date: "التاريخ",
    initiative: "المبادرة",
    viewDetails: "عرض التفاصيل",
    // Transaction Status
    pending: "قيد الانتظار",
    completed: "مكتملة",
    failed: "فشلت",
    inbound: "واردة",
    outbound: "صادرة",
    transactionId: "معرف المعاملة",
    direction: "الاتجاه",
    fee: "الرسوم",
    commission: "العمولة",
    settled: "مستقرة",
    yes: "نعم",
    no: "لا",
    initiativeType: "نوع المبادرة",
    actions: "الإجراءات",
    // Initiative Statuses
    statusActive: "نشطة",
    statusInactive: "غير نشطة",
    statusDraft: "مسودة",
    statusIncoming: "قادمة",
    statusFunded: "ممولة",
    statusPublished: "منشورة",
    statusPaused: "متوقفة مؤقتًا",
    statusPendingApproval: "في انتظار الموافقة",
    statusCompleted: "مكتملة",
    statusExpired: "منتهية",
    statusPending: "قيد الانتظار",
    statusCancelled: "ملغاة",
    // Initiative Types
    typeWalk: "مبادرة المشي",
    typeJuthoor: "مبادرة جذور",
    // Initiative Actions
    setBudget: "تعيين الميزانية",
    setBudgetAction: "تعيين ميزانية",
    // Financial Breakdowns
    dailyBreakdown: "التفصيل اليومي",
    weeklyBreakdown: "التفصيل الأسبوعي",
    monthlyBreakdown: "التفصيل الشهري",
    spendingDistribution: "توزيع المصروفات",
    earnings: "الإيرادات",
    spendings: "المصروفات",
    // Initiative Statistics
    initiativeStats: "إحصائيات المبادرات",
    totalInitiatives: "إجمالي المبادرات",
    activeInitiatives: "المبادرات النشطة",
    participantsRewarded: "المشاركون المكافئون",
    participants: "المشاركون",
    totalEnablers: "إجمالي الممكنين",
    communitiesReached: "المجتمعات المستهدفة",
    participationGrowth: "نمو المشاركة",
    budgetUsage: "استخدام الميزانية",
    budgetUsed: "الميزانية المستخدمة",
    budgetRemaining: "الميزانية المتبقية",
    usagePercentage: "نسبة الاستخدام",
    // Time Periods
    daily: "يومي",
    weekly: "أسبوعي",
    monthly: "شهري",
    monday: "الإثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت",
    sunday: "الأحد",
    week1: "الأسبوع ١",
    week2: "الأسبوع ٢",
    week3: "الأسبوع ٣",
    week4: "الأسبوع ٤",
    week5: "الأسبوع ٥",
    // Months
    jan: "يناير",
    feb: "فبراير",
    mar: "مارس",
    apr: "أبريل",
    may: "مايو",
    jun: "يونيو",
    jul: "يوليو",
    aug: "أغسطس",
    sep: "سبتمبر",
    oct: "أكتوبر",
    nov: "نوفمبر",
    dec: "ديسمبر",
    // UI States
    loading: "جاري التحميل",
    loadingData: "جاري تحميل البيانات...",
    error: "خطأ",
    errorLoadingData: "فشل تحميل البيانات",
    retry: "إعادة المحاولة",
    retryLoading: "إعادة تحميل البيانات",
    noData: "لا توجد بيانات",
    noDataAvailable: "لا توجد بيانات متاحة حاليًا",
    noTransactions: "لا توجد معاملات",
    noTransactionsMessage: "سيظهر سجل معاملاتك هنا بمجرد إجراء أول معاملة",
    noInitiatives: "لا توجد مبادرات",
    noInitiativesMessage: "لا توجد مبادرات متاحة حاليًا",
    // Filters
    filter: "تصفية",
    filterBy: "تصفية حسب",
    search: "بحث",
    searchPlaceholder: "ابحث عن...",
    category: "الفئة",
    all: "الكل",
    community: "مجتمعي",
    green: "أخضر",
    unknown: "غير معروف",
    // Initiative fields
    title: "العنوان",
    budget: "الميزانية",
    description: "الوصف",
    startDate: "تاريخ البداية",
    endDate: "تاريخ النهاية",
    enablers: "الممكنون",
    // Initiative status
    draft: "مسودة",
    published: "منشور",
    active: "نشط",
    paused: "متوقف مؤقتًا",
    cancelled: "ملغى",
    // Pagination
    page: "صفحة",
    of: "من",
    previous: "السابق",
    next: "التالي",
    showing: "عرض",
    results: "نتائج",
    // Create Initiative Wizard
    createInitiative: "إنشاء مبادرة",
    newInitiative: "إنشاء مبادرة جديدة",
    selectTemplate: "اختر قالب مبادرتك",
    templateCategory: "فئة القالب",
    configureRewards: "تكوين المكافآت والتأثير",
    stepSelectInitiative: "حدد مبادرتك",
    stepConfigureRewards: "تكوين المكافآت والتأثير",
    comingSoon: "قريباً",
    initiativeTitle: "عنوان المبادرة",
    initiativeTitleEn: "(English) عنوان المبادرة",
    initiativeScope: "نطاق المبادرة",
    scopeCooperative: "تعاونية",
    scopeIndividual: "فردية",
    scopeInstitutional: "مؤسسية",
    participationLimit: "حد المشاركة",
    unlimited: "غير محدود",
    custom: "مخصص",
    cityField: "المدينة",
    communityField: "المجتمع",
    communities: "المجتمعات",
    communitiesOptional: "المجتمعات (اختياري)",
    chooseOption: "اختر الخيارات",
    templateSocial: "اجتماعي",
    templateCommunity: "مجتمعي",
    templateEnvironmental: "بيئي",
    // Wizard Step 2 — Rewards
    initiativeDuration: "مدة المبادرة",
    fixedDuration: "محددة المدة",
    openDuration: "مفتوحة المدة",
    durationOneMonth: "شهر واحد",
    durationSixMonths: "6 أشهر",
    durationOneYear: "سنة واحدة",
    customDuration: "مخصص",
    impactStructure: "هيكل الأثر",
    impactStructureSubtitle: "اضبط إعدادات المكافآت ومعدل تحويل عملة أثر عند تحقيق الأهداف.",
    targetGoal: "الخطوات المستهدفة",
    goalTimeDays: "الحد الزمني لتحقيق الهدف (بالأيام)",
    rewardOnCompletion: "المكافأة عند الإتمام",
    conversionRate: "معدل تحويل الأثر",
    aiRateHint: "غير متأكد من المعدل؟ اطلب من الذكاء الاصطناعي اقتراح معدل مثالي لنوع مبادرتك.",
    getAiRecommendation: "احصل على توصية الذكاء الاصطناعي",
    budgetEstimator: "تقدير الميزانية",
    estimateByUsers: "تقدير حسب المستخدمين",
    estimateByBudget: "تقدير حسب الميزانية",
    expectedParticipants: "أدخل العدد المتوقع للمشاركين",
    rewardGivenEvery: "المكافأة المعطاة كل:",
    rewardsPerPeriod: "مكافآت بعملة أثر لكل فترة:",
    initiativeDurationLabel: "مدة المبادرة:",
    rewardPeriodsCount: "عدد فترات المكافأة خلال المبادرة:",
    estimatedBudgetRequired: "الميزانية المقدرة المطلوبة:",
    estimatedBudgetSar: "الميزانية المقدرة بـ NC:",
    budgetEstimatorNote: "هذا التقدير يفترض أن كل مشارك يحقق هدفه في كل فترة مكافأة. قد تكون التكاليف الفعلية أقل إذا كانت معدلات المشاركة أو تحقيق الأهداف أقل.",
    budgetAmount: "مبلغ الميزانية (CP)",
    maxParticipants: "الحد الأقصى للمشاركين:",
    // Action modals
    fundInitiative: "تمويل المبادرة",
    fundInitiativeWarning: "ملاحظة: بمجرد تمويل هذه المبادرة، لن تتمكن من تحديثها.",
    confirmFund: "تمويل المبادرة",
    inviteParticipant: "دعوة مشارك",
    shareImpact: "شارك التأثير",
    shareImpactTagline: "كل حركة عظيمة تحتاج إلى أشخاص عظماء",
    whoToInvite: "من ستدعو؟",
    inviteIdentifierPlaceholder: "أدخل بريدهم الإلكتروني",
    existingEnabler: "ممكِّن حالي",
    inviteByEmail: "دعوة عبر البريد الإلكتروني",
    selectEnabler: "اختر ممكِّناً",
    noEnablersAvailable: "لا يوجد ممكِّنون متاحون للدعوة",
    requestJoin: "اطلب الانضمام",
    reactivateInitiative: "إعادة تفعيل المبادرة",
    setOpenEnded: "تعيين كمستمرة المدة",
    usePreviousSettings: "استخدام الإعدادات السابقة",
    usePreviousSettingsNote: "إبقاء جميع التكوينات مطابقة للمبادرة السابقة.",
    // Initiative Details
    initiativeDetails: "تفاصيل المبادرة",
    infoTab: "التفاصيل",
    statisticsTab: "الإحصائيات",
    shareInitiative: "مشاركة المبادرة",
    createReport: "إنشاء تقرير",
    cancelAction: "إلغاء",
    backToInitiatives: "العودة إلى المبادرات",
    inviteSentSuccess: "تم إرسال الدعوة بنجاح!",
    locationScope: "النطاق / الموقع",
    timeline: "الجدول الزمني",
    goalStructure: "هيكل الهدف والمكافأة",
    mainGoal: "الهدف الرئيسي",
    pointsPerGoal: "النقاط لكل هدف",
    conversionRateLabel: "معدل التحويل",
    partnerOrganisations: "الجهات المبادرة",
    fundsCollected: "الأموال المجمعة",
    avgGrowth: "متوسط النمو",
    millionsImpact: "مليون",
    participationOverTime: "المشاركة على مر الوقت",
    genderDistribution: "التوزيع حسب الجنس",
    joinedStores: "المحلات المنضمة",
    businessCategories: "توزيع فئات الأعمال",
    localLeaders: "القادة المحليون",
    noCategoriesData: "لا توجد بيانات متاحة",
    noCategoriesMessage: "سيتم عرض الفئات فور بدء النشاط",
    noLeadersYet: "لا يوجد قادة بعد",
    noLeadersMessage: "ستظهر إحصائيات لوحة الصدارة هنا بمجرد حصول المشاركين على المكافآت.",
    female: "أنثى",
    male: "ذكر",
    allStores: "جميع المحلات",
    storesViaLink: "المحلات المنضمة عبر الرابط",
    expired: "منتهية",
    // Settings Page
    settingsTitle: "الإعدادات",
    profileSettings: "إعدادات الملف الشخصي",
    orgName: "اسم الجهة المبادرة",
    orgDescription: "وصف قصير",
    sector: "الصناعة / القطاع",
    orgEmail: "البريد الإلكتروني للجهة المبادرة",
    websiteField: "الموقع الإلكتروني",
    saveChanges: "حفظ التغييرات",
    notificationPreferences: "تفضيلات الإشعارات",
    newInitiativesNotif: "مبادرات جديدة",
    contributionRequestsNotif: "طلبات المساهمة",
    initiativeUpdatesNotif: "تحديثات المبادرات",
    newInitiativesNotifDesc: "احصل على إشعارات حول المبادرات الجديدة",
    contributionRequestsNotifDesc: "احصل على إشعارات عند استلام طلبات مساهمة",
    initiativeUpdatesNotifDesc: "احصل على إشعارات حول تحديثات المبادرات",
    languagePreferences: "تفضيلات اللغة",
    arabicLang: "العربية",
    englishLang: "English",
    changePassword: "إعادة تعيين كلمة المرور",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    changePasswordBtn: "تغيير كلمة المرور",
    passwordChanged: "تم تغيير كلمة المرور بنجاح",
    profileUpdated: "تم تحديث الملف الشخصي بنجاح",
    avatarUploaded: "تم رفع الشعار بنجاح",
    sectorCharity: "القطاع الخيري",
    sectorGovernment: "القطاع الحكومي",
    sectorPrivate: "القطاع الخاص",
    selectSector: "اختر القطاع",
    partnerLogo: "شعار الجهة المبادرة",
    fileTooLarge: "حجم الملف يتجاوز الحد المسموح به (2 ميغابايت)",
    enterCurrentPassword: "أدخل كلمة المرور الحالية",
    enterNewPassword: "أدخل كلمة المرور الجديدة",
    reenterNewPassword: "أعد إدخال كلمة المرور الجديدة",
    passwordMinLength: "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
    passwordMismatch: "كلمتا المرور غير متطابقتين",
    // Contributions Page
    contributionsTitle: "المساهمات",
    contributionRequests: "طلبات المساهمة",
    myContributions: "مساهماتي",
    trackRequests: "تتبع وإدارة طلبات المساهمة الجديدة",
    trackContributions: "قائمة بجميع المساهمات التي قمت بإنشائها أو المشاركة فيها",
    searchByName: "البحث بالاسم...",
    selectStatusFilter: "اختر الحالة",
    receivedDir: "استلم",
    sentDir: "أرسل",
    requestDate: "تاريخ الطلب",
    requestedBy: "تم الطلب من قبل",
    acceptAction: "قبول",
    rejectAction: "رفض",
    creationDate: "تاريخ الإنشاء",
    fundedBudget: "الميزانية الممولة",
    noContributionRequests: "لا توجد طلبات مساهمة حالياً",
    noContributionRequestsDesc: "سيتم عرض الطلبات هنا بمجرد استلامها",
    noContributions: "لم يتم العثور على مساهمات",
    noContributionsDesc: "ابدأ بالمساهمة في المبادرات المتاحة لتراها هنا",
    showMore: "عرض المزيد",
    statusAccepted: "مقبول",
    statusRejected: "مرفوض",
    // Password Reset
    forgotPasswordTitle: "استعادة كلمة المرور",
    forgotPasswordDesc: "أدخل بريدك الإلكتروني وسنرسل لك رمز التحقق",
    sendOtp: "إرسال الرمز",
    otpSent: "تم إرسال رمز التحقق إلى بريدك الإلكتروني",
    backToLogin: "العودة إلى تسجيل الدخول",
    verifyOtpTitle: "التحقق من الرمز",
    verifyOtpDesc: "أدخل الرمز المرسل إلى بريدك الإلكتروني",
    otpLabel: "رمز التحقق",
    otpPlaceholder: "أدخل الرمز المكوّن من 6 أرقام",
    resendOtp: "إعادة إرسال الرمز",
    resendOtpCooldown: "إعادة الإرسال بعد {seconds} ثوانٍ",
    verifyOtp: "تحقق",
    resetPasswordTitle: "تعيين كلمة مرور جديدة",
    resetPasswordDesc: "أدخل كلمة المرور الجديدة",
    newPasswordLabel: "كلمة المرور الجديدة",
    confirmPasswordLabel: "تأكيد كلمة المرور",
    resetPasswordBtn: "تعيين كلمة المرور",
    passwordResetSuccess: "تم تعيين كلمة المرور بنجاح. يمكنك تسجيل الدخول الآن.",
    // Notifications
    close: "إغلاق",
    notificationsTitle: "الإشعارات",
    markAllRead: "تعيين الكل كمقروء",
    noNotifications: "لا توجد إشعارات",
    noNotificationsDesc: "ستظهر إشعاراتك هنا",
    notificationUnread: "غير مقروء",
    // Initiatives Extra
    editInitiative: "تعديل المبادرة",
    deleteInitiative: "حذف المبادرة",
    deleteInitiativeConfirmTitle: "تأكيد الحذف",
    deleteInitiativeConfirmMsg: "هل أنت متأكد من حذف هذه المبادرة؟ لا يمكن التراجع عن هذا الإجراء.",
    joinInitiative: "الانضمام للمبادرة",
    joinBudgetLabel: "مبلغ الميزانية",
    joinBudgetPlaceholder: "أدخل المبلغ",
    joinSuccess: "تم الانضمام للمبادرة بنجاح",
    openInitiativesTab: "المبادرات المتاحة",
    participatedTab: "المشاركة",
    myInitiativesTab: "مبادراتي",
    incomingTab: "الواردة",
    noOpenInitiatives: "لا توجد مبادرات متاحة للانضمام",
    noParticipated: "لم تنضم إلى أي مبادرات بعد",
    // Wallet Extra
    topUpWallet: "شحن المحفظة",
    topUpAmount: "المبلغ",
    topUpMethod: "طريقة الدفع",
    topUpSuccess: "تم شحن المحفظة بنجاح",
    // Analytics
    walkStatsTitle: "إحصائيات مبادرة المشي",
    treeStatsTitle: "إحصائيات مبادرة الأشجار",
    shopsStatsTitle: "إحصائيات مبادرة المحلات",
    saverStatsTitle: "إحصائيات مبادرة التوفير",
    interestAnalyticsTitle: "تحليلات الاهتمام",
    totalSteps: "إجمالي الخطوات",
    totalDistance: "إجمالي المسافة",
    avgSteps: "متوسط الخطوات",
    avgDistance: "متوسط المسافة",
    highestSteps: "أعلى خطوات",
    totalTreesPlanted: "إجمالي الأشجار المزروعة",
    goalTrees: "هدف الأشجار",
    avgTrees: "متوسط الأشجار",
    totalAmountSpent: "إجمالي المبلغ المنفق",
    goalAmount: "المبلغ المستهدف",
    totalPointsEarned: "إجمالي النقاط",
    totalSavings: "إجمالي المدخرات",
    totalRewardsDistributed: "المكافآت الموزعة",
    progressPercentage: "نسبة الإنجاز",
    totalInterested: "إجمالي المهتمين",
    analyticsUnavailable: "الإحصائيات غير متاحة لهذه المبادرة",
    // AI Translation
    autoTranslate: "ترجمة تلقائية للعربية",
    translating: "جارٍ الترجمة...",
    translationError: "فشلت الترجمة. يمكنك الكتابة يدوياً.",
    // Sidebar
    navWallet: "المحفظة",
    navAnalytics: "التحليلات",
    navContributions: "المساهمات",
    // Walking Initiative Details
    walkingAreaType: "نوع منطقة المشي",
    openExploration: "استكشاف مفتوح",
    structuredPath: "مسار محدد",
    pathsCount: "عدد المسارات",
    totalPathDistance: "إجمالي مسافة المسارات",
    locationsCount: "عدد المواقع",
    noLocations: "لا توجد مواقع محددة",
    noPaths: "لا توجد مسارات محددة",
    locations: "المواقع",
    paths: "المسارات",
    segments: "الأجزاء",
    meters: "متر",
    participantLimit: "حد المشاركة",
    goalSteps: "هدف الخطوات",
    rewardPerGoal: "المكافأة لكل هدف",
    goalTimeLimit: "الحد الزمني",
    months: "أشهر",
    noTimeLimit: "بدون حد زمني",
    rewardHistory: "سجل المكافآت",
    goalsCompleted: "الأهداف المكتملة",
    greenPointsEarned: "النقاط الخضراء المكتسبة",
    progressToNextGoal: "التقدم نحو الهدف التالي",
    stepsRemaining: "الخطوات المتبقية",
    sidebarFaq: "الأسئلة الشائعة",
    sidebarHowItWorks: "كيف يعمل",
    sidebarTerms: "الشروط والأحكام",
    // About page
    aboutHeroTitle: "عن NCircle",
    aboutHeroSubtitle: "بناء المجتمعات من خلال الأثر الهادف",
    missionTitle: "مهمتنا",
    missionBody: "تمكين المنظمات والمجتمعات من إحداث أثر بيئي واجتماعي قابل للقياس.",
    visionTitle: "رؤيتنا",
    visionBody: "عالم تمتلك فيه كل مجتمع الأدوات اللازمة لإحداث تغيير إيجابي.",
    valuesTitle: "قيمنا",
    value1Title: "الأثر",
    value1Body: "كل إجراء يُحتسب نحو هدف قابل للقياس.",
    value2Title: "المجتمع",
    value2Body: "المبادرات مبنية مع المجتمعات ومن أجلها.",
    value3Title: "الشفافية",
    value3Body: "أهداف واضحة، نتائج قابلة للقياس، تقارير مفتوحة.",
    aboutCtaTitle: "مستعد لإحداث الأثر؟",
    aboutCtaButton: "ابدأ الآن",
    // Public initiatives page
    publicInitiativesTitle: "المبادرات النشطة",
    publicInitiativesSubtitle: "استكشف المبادرات المجتمعية الجارية والقادمة",
    initiativesComingSoon: "مبادرات قادمة قريباً",
    initiativesComingSoonBody: "نعمل على إعداد مبادرات جديدة مثيرة. تفقد مجدداً قريباً.",
    loginForFullAccess: "تريد المشاركة؟",
    loginForFullAccessBody: "سجّل دخولك للانضمام إلى المبادرات وتتبع أثرك وكسب المكافآت.",
    viewInitiativeDetails: "عرض التفاصيل",
    // Initiative account request form
    initiativeRequestTitle: "طلب تفعيل حساب الجهة المبادرة",
    initiativeRequestSubtitle: "أرسل بياناتك وسيتواصل معك فريقنا لتفعيل حسابك.",
    fullName: "الاسم الكامل",
    emailAddress: "البريد الإلكتروني",
    companyOrganisation: "الجهة / الشركة",
    phoneNumber: "رقم الجوال",
    submitRequest: "إرسال الطلب",
    requestSentTitle: "تم إرسال الطلب",
    requestSentBody: "شكراً لك. سيتواصل معك فريقنا قريباً لاستكمال تفعيل الحساب.",
    emailAlreadyUsed: "هذا البريد الإلكتروني مسجّل مسبقاً. يرجى استخدام بريد آخر.",
    optional: "(اختياري)",
    entityNameAr: "اسم الجهة المبادرة",
    entityNameEn: "اسم الجهة المبادرة (English)",
    entityType: "نوع الجهة",
    entityTypeSelectPlaceholder: "اختر نوع الجهة",
    responsiblePerson: "اسم الشخص المسؤول",
    whatsappNumber: "رقم واتساب الشخص المسؤول",
    website: "الموقع الإلكتروني",
    message: "رسالة",
    organizationLogo: "شعار المنظمة",
    uploadLogoText: "قم برفع شعار مؤسستك",
    acceptedFormats: "الصيغ المقبولة: JPEG, PNG",
    agreeToTerms: "أوافق على الشروط والأحكام",
    agreeToTermsError: "يجب الموافقة على الشروط والأحكام للمتابعة",
    invalidFileType: "صيغة الملف غير مقبولة. يُسمح بـ JPEG و PNG فقط",
    // 012-partner-wallet-ui
    periodDaily: "يومي",
    periodWeekly: "أسبوعي",
    periodMonthly: "شهري",
    periodCustom: "مخصص",
    periodFrom: "من",
    periodTo: "إلى",
    transactionVolume: "حجم المعاملات",
    pointsEarned: "النقاط المكتسبة",
    totalPoints: "إجمالي النقاط",
    settlementRate: "نسبة التسوية",
    commissionSummary: "ملخص العمولة",
    totalFeesPaid: "إجمالي الرسوم المدفوعة",
    totalCommissionEarned: "إجمالي العمولة المكتسبة",
    commissionRate: "معدل العمولة",
    netRevenue: "صافي الإيرادات",
    topUpHistory: "سجل الشحن",
    loadMore: "تحميل المزيد",
    copyId: "نسخ المعرّف",
    copied: "تم النسخ!",
    activityFeed: "النشاط الأخير",
    viewAll: "عرض الكل",
    initiativeImpact: "أثر المبادرات",
    totalParticipants: "إجمالي المشاركين",
    pointsDistributed: "النقاط الموزعة",
    quickFilterAll: "الكل",
    quickFilterInbound: "وارد",
    quickFilterOutbound: "صادر",
    quickFilterSettled: "مُسوَّى",
    quickFilterPending: "معلّق",
    quickFilterFailed: "فشل",
    exportCsv: "تصدير CSV",
    exportSelected: "تصدير المحدد",
    noActivityYet: "لا يوجد نشاط حديث",
    estimatedFee: "الرسوم التقديرية",
    feeRate: "معدل الرسوم",
    confirmTopUp: "تأكيد الشحن",
    topUpSummary: "ملخص الشحن",
    back: "رجوع",
    confirm: "تأكيد",
    presetAmount: "مبلغ سريع",
    topUpPending: "تم تقديم طلب الشحن وهو في انتظار موافقة المشرف.",
    sarEquivalent: "ما يعادل بـ NC",
    statusPendingMunicipalityApproval: "في انتظار موافقة الأمانة",
    statusMunicipalityApproved: "تمت الموافقة من الأمانة",
    statusMunicipalityRejected: "رُفضت من الأمانة",
    statusPendingAdminApproval: "في انتظار موافقة المسؤول",
    statusAdminApproved: "تمت الموافقة من المسؤول",
    statusPlantingInProgress: "الزراعة جارية",
    juthoorWizardStepTitle: "إعداد الأشجار والمكافآت",
    totalTrees: "إجمالي الأشجار",
    rewardPerTree: "المكافأة لكل شجرة",
    maxTreesPerClient: "الحد الأقصى للشجر لكل عميل",
    selectLand: "اختر الأرض",
    treesPlanted: "الأشجار المزروعة",
    treesRewarded: "الأشجار المكافأ عليها",
    treesSold: "الأشجار المباعة",
    treesReserved: "الأشجار المحجوزة",
    treesAvailable: "الأشجار المتاحة",
    totalRewardsCommitted: "المكافآت الملتزم بها (نقاط)",
    rewardsEarned: "المكافآت المكتسبة (نقاط)",
    plantingProgress: "تقدم الزراعة",
    participationLedger: "سجل المشاركة",
    joinedDate: "تاريخ الانضمام",
    ecosystemFlow: "مسار المبادرة",
    activeLand: "الأرض المفعّلة",
    sustainableImpact: "الأثر البيئي",
    purchasePrice: "سعر الشراء (نت زيرو)",
    sellingPrice: "سعر البيع للعميل",
    marginPerTree: "الهامش لكل شجرة",
    atharProfitShare: "حصة أثر من الربح (%)",
    municipalityProfitShare: "حصة الأمانة من الربح (%)",
    estimatedRevenue: "الإيراد الكلي المتوقع",
    totalPurchaseCost: "إجمالي تكلفة الشراء",
    pendingApprovals: "بانتظار الموافقة",
    profitLedger: "سجل الأرباح",
    rejectionReason: "سبب الرفض",
    editAndResubmit: "تعديل وإعادة الإرسال",
    submitForApproval: "إرسال للموافقة",
    approveInitiative: "الموافقة على المبادرة",
    rejectInitiative: "رفض المبادرة",
    setPricing: "تحديد التسعير",
    juthoorAdminDashboard: "لوحة تحكم جذور",
    netzeroPurchasedTrees: "أشجار مشتراة من نت زيرو",
    distributedProfit: "الأرباح الموزعة",
    pendingProfit: "الأرباح المعلقة",
    pricingHistory: "سجل التسعير",
    enterRejectionReason: "أدخل سبب الرفض",
    confirmApproval: "تأكيد الموافقة",
    approvalConfirmText: "هل أنت متأكد من الموافقة على هذه المبادرة؟ سيتم إنشاء مشروع نت زيرو تلقائياً.",
    totalClients: "إجمالي العملاء",
    totalRevenue: "إجمالي الإيرادات",
    totalProfit: "إجمالي الأرباح",
    atharProfit: "أرباح أثر",
    municipalityProfit: "أرباح الأمانة"
  },
  en: {
    brand: "Athr",
    home: "Home",
    about: "About",
    initiatives: "Initiatives",
    termsAndConditions: "Terms & Conditions",
    privacyPolicy: "Privacy Policy",
    login: "Login",
    startNow: "Start Now",
    heroTitle: "Be part of change. Strengthen community impact.",
    heroSubtitle:
      "Launch initiatives, support communities, and track measurable outcomes in one platform.",
    whoAreYou: "Who Are You?",
    selectRole: "Choose your role",
    merchant: "Merchant",
    initiativeEntity: "Initiative Organization",
    continueAsMerchant: "Continue as Merchant",
    continueAsInitiative: "Continue as Initiative",
    welcomeBack: "Welcome back to Athr",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    invalidEmail: "Please enter a valid email",
    requiredField: "This field is required",
    logout: "Logout",
    loginFailed: "Login failed. Please verify your credentials and try again",
    navOverview: "Overview",
    navPrograms: "Programs",
    navSettings: "Settings",
    navNotifications: "Notifications",
    quickActionsTitle: "Quick Actions",
    quickActionsSubtitle: "Jump back into your most recent tasks",
    quickActionsCreateInitiative: "Create initiative",
    quickActionsViewApprovals: "View approvals",
    quickActionsInviteMember: "Invite member",
    sidebarNavigation: "Sidebar navigation",
    sidebarBadgeLabel: "Pending items",
    sidebarCollapse: "Collapse sidebar",
    sidebarExpand: "Expand sidebar",
    sidebarCloseDrawer: "Close menu",
    // Wallet Dashboard
    walletBalance: "Wallet Balance",
    nationalCurrency: "NC",
    greenPoints: "Green Point",
    smartPoints: "Social Point",
    communityPoints: "Community Point",
    financialOverview: "Financial Overview",
    balanceOverview: "Balance Overview",
    totalBalance: "Total Balance",
    totalEarnings: "Total Earnings",
    totalSpendings: "Total Spendings",
    netBalance: "Net Balance",
    transactionHistory: "Transaction History",
    transactions: "Transactions",
    amount: "Amount",
    type: "Type",
    status: "Status",
    date: "Date",
    initiative: "Initiative",
    viewDetails: "View Details",
    // Transaction Status
    pending: "Pending",
    completed: "Completed",
    failed: "Failed",
    inbound: "Inbound",
    outbound: "Outbound",
    transactionId: "Transaction ID",
    direction: "Direction",
    fee: "Fee",
    commission: "Commission",
    settled: "Settled",
    yes: "Yes",
    no: "No",
    initiativeType: "Initiative Type",
    actions: "Actions",
    // Initiative Statuses
    statusActive: "Active",
    statusInactive: "Inactive",
    statusDraft: "Draft",
    statusIncoming: "Incoming",
    statusFunded: "Funded",
    statusPublished: "Published",
    statusPaused: "Paused",
    statusPendingApproval: "Pending Approval",
    statusCompleted: "Completed",
    statusExpired: "Expired",
    statusPending: "Pending",
    statusCancelled: "Cancelled",
    // Initiative Types
    typeWalk: "Walk Initiative",
    typeJuthoor: "Juthoor Initiative",
    // Initiative Actions
    setBudget: "Set Budget",
    setBudgetAction: "Set Budget",
    // Financial Breakdowns
    dailyBreakdown: "Daily Breakdown",
    weeklyBreakdown: "Weekly Breakdown",
    monthlyBreakdown: "Monthly Breakdown",
    spendingDistribution: "Spending Distribution",
    earnings: "Earnings",
    spendings: "Spendings",
    // Initiative Statistics
    initiativeStats: "Initiative Statistics",
    totalInitiatives: "Total Initiatives",
    activeInitiatives: "Active Initiatives",
    participantsRewarded: "Participants Rewarded",
    participants: "Participants",
    totalEnablers: "Total Enablers",
    communitiesReached: "Communities Reached",
    participationGrowth: "Participation Growth",
    budgetUsage: "Budget Usage",
    budgetUsed: "Budget Used",
    budgetRemaining: "Budget Remaining",
    usagePercentage: "Usage Percentage",
    // Time Periods
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    week1: "Week 1",
    week2: "Week 2",
    week3: "Week 3",
    week4: "Week 4",
    week5: "Week 5",
    // Months
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    jun: "June",
    jul: "July",
    aug: "August",
    sep: "September",
    oct: "October",
    nov: "November",
    dec: "December",
    // UI States
    loading: "Loading",
    loadingData: "Loading data...",
    error: "Error",
    errorLoadingData: "Failed to load data",
    retry: "Retry",
    retryLoading: "Retry loading data",
    noData: "No data",
    noDataAvailable: "No data available",
    noTransactions: "No transactions",
    noTransactionsMessage: "Your transaction history will appear here once you make your first transaction",
    noInitiatives: "No initiatives",
    noInitiativesMessage: "No initiatives are currently available",
    // Filters
    filter: "Filter",
    filterBy: "Filter by",
    search: "Search",
    searchPlaceholder: "Search...",
    category: "Category",
    all: "All",
    community: "Community",
    green: "Green",
    unknown: "Unknown",
    // Initiative fields
    title: "Title",
    budget: "Budget",
    description: "Description",
    startDate: "Start Date",
    endDate: "End Date",
    enablers: "Enablers",
    // Initiative status
    draft: "Draft",
    published: "Published",
    active: "Active",
    paused: "Paused",
    cancelled: "Cancelled",
    // Pagination
    page: "Page",
    of: "of",
    previous: "Previous",
    next: "Next",
    showing: "Showing",
    results: "results",
    // Create Initiative Wizard
    createInitiative: "Create Initiative",
    newInitiative: "Create New Initiative",
    selectTemplate: "Choose your initiative template",
    templateCategory: "Template Category",
    configureRewards: "Configure Rewards & Impact",
    stepSelectInitiative: "Select Initiative",
    stepConfigureRewards: "Configure Rewards & Impact",
    comingSoon: "Coming Soon",
    initiativeTitle: "Initiative Title",
    initiativeTitleEn: "Initiative Title (English)",
    initiativeScope: "Initiative Scope",
    scopeCooperative: "Cooperative",
    scopeIndividual: "Individual",
    scopeInstitutional: "Institutional",
    participationLimit: "Participation Limit",
    unlimited: "Unlimited",
    custom: "Custom",
    cityField: "City",
    communityField: "Community",
    communities: "Communities",
    communitiesOptional: "Communities (optional)",
    chooseOption: "Choose option",
    templateSocial: "Social",
    templateCommunity: "Community",
    templateEnvironmental: "Environmental",
    // Wizard Step 2 — Rewards
    initiativeDuration: "Initiative Duration",
    fixedDuration: "Fixed Duration",
    openDuration: "Open-ended",
    durationOneMonth: "One Month",
    durationSixMonths: "6 Months",
    durationOneYear: "One Year",
    customDuration: "Custom",
    impactStructure: "Impact Structure",
    impactStructureSubtitle: "Configure reward settings and the Athr currency conversion rate upon goal achievement.",
    targetGoal: "Target Steps",
    goalTimeDays: "Goal Time Limit (in days)",
    rewardOnCompletion: "Reward on Completion",
    conversionRate: "Athr Conversion Rate",
    aiRateHint: "Not sure about the rate? Ask AI to suggest an optimal rate for your initiative type.",
    getAiRecommendation: "Get AI Recommendation",
    budgetEstimator: "Budget Estimator",
    estimateByUsers: "Estimate by Users",
    estimateByBudget: "Estimate by Budget",
    expectedParticipants: "Enter expected number of participants",
    rewardGivenEvery: "Reward given every:",
    rewardsPerPeriod: "Athr rewards per period:",
    initiativeDurationLabel: "Initiative duration:",
    rewardPeriodsCount: "Reward periods during initiative:",
    estimatedBudgetRequired: "Estimated budget required:",
    estimatedBudgetSar: "Estimated budget in NC:",
    budgetEstimatorNote: "This estimate assumes every participant achieves their goal in every reward period. Actual costs may be lower if participation or goal achievement rates are lower.",
    budgetAmount: "Budget Amount (CP)",
    maxParticipants: "Max participants:",
    // Action modals
    fundInitiative: "Fund Initiative",
    fundInitiativeWarning: "Note: Once you fund this initiative, you will not be able to update it.",
    confirmFund: "Fund Initiative",
    inviteParticipant: "Invite Participant",
    shareImpact: "Share the Impact",
    shareImpactTagline: "Every great movement needs great people",
    whoToInvite: "Who will you invite?",
    inviteIdentifierPlaceholder: "Enter their email",
    existingEnabler: "Existing enabler",
    inviteByEmail: "Invite by email",
    selectEnabler: "Select an enabler",
    noEnablersAvailable: "No enablers available to invite",
    requestJoin: "Request to Join",
    reactivateInitiative: "Reactivate Initiative",
    setOpenEnded: "Set as open-ended",
    usePreviousSettings: "Use previous settings",
    usePreviousSettingsNote: "Keep all configurations identical to the previous initiative.",
    // Initiative Details
    initiativeDetails: "Initiative Details",
    infoTab: "Details",
    statisticsTab: "Statistics",
    shareInitiative: "Share Initiative",
    createReport: "Create Report",
    cancelAction: "Cancel",
    backToInitiatives: "Back to Initiatives",
    inviteSentSuccess: "Invitation sent successfully!",
    locationScope: "Scope / Location",
    timeline: "Timeline",
    goalStructure: "Goal & Reward Structure",
    mainGoal: "Main Goal",
    pointsPerGoal: "Points per Goal",
    conversionRateLabel: "Conversion Rate",
    partnerOrganisations: "Partner Organisations",
    fundsCollected: "Funds Collected",
    avgGrowth: "Avg Growth",
    millionsImpact: "Million",
    participationOverTime: "Participation Over Time",
    genderDistribution: "Gender Distribution",
    joinedStores: "Joined Stores",
    businessCategories: "Business Category Distribution",
    localLeaders: "Local Leaders",
    noCategoriesData: "No data available",
    noCategoriesMessage: "Categories will appear once activity begins",
    noLeadersYet: "No leaders yet",
    noLeadersMessage: "Leaderboard statistics will appear here once participants earn rewards.",
    female: "Female",
    male: "Male",
    allStores: "All Stores",
    storesViaLink: "Stores joined via link",
    expired: "Expired",
    // Settings Page
    settingsTitle: "Settings",
    profileSettings: "Profile Settings",
    orgName: "Organization Name",
    orgDescription: "Short Description",
    sector: "Industry / Sector",
    orgEmail: "Organization Email",
    websiteField: "Website",
    saveChanges: "Save Changes",
    notificationPreferences: "Notification Preferences",
    newInitiativesNotif: "New Initiatives",
    contributionRequestsNotif: "Contribution Requests",
    initiativeUpdatesNotif: "Initiative Updates",
    newInitiativesNotifDesc: "Get notified about new initiatives",
    contributionRequestsNotifDesc: "Get notified when you receive contribution requests",
    initiativeUpdatesNotifDesc: "Get notified about initiative updates",
    languagePreferences: "Language Preferences",
    arabicLang: "العربية",
    englishLang: "English",
    changePassword: "Reset Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    changePasswordBtn: "Change Password",
    passwordChanged: "Password changed successfully",
    profileUpdated: "Profile updated successfully",
    avatarUploaded: "Avatar uploaded successfully",
    sectorCharity: "Charity Sector",
    sectorGovernment: "Government Sector",
    sectorPrivate: "Private Sector",
    selectSector: "Select Sector",
    partnerLogo: "Organization Logo",
    fileTooLarge: "File size exceeds the maximum allowed limit (2MB)",
    enterCurrentPassword: "Enter current password",
    enterNewPassword: "Enter new password",
    reenterNewPassword: "Re-enter new password",
    passwordMinLength: "Password must be at least 8 characters",
    passwordMismatch: "Passwords do not match",
    // Contributions Page
    contributionsTitle: "Contributions",
    contributionRequests: "Contribution Requests",
    myContributions: "My Contributions",
    trackRequests: "Track and manage new contribution requests",
    trackContributions: "List of all contributions you created or participated in",
    searchByName: "Search by name...",
    selectStatusFilter: "Select Status",
    receivedDir: "Received",
    sentDir: "Sent",
    requestDate: "Request Date",
    requestedBy: "Requested By",
    acceptAction: "Accept",
    rejectAction: "Reject",
    creationDate: "Creation Date",
    fundedBudget: "Funded Budget",
    noContributionRequests: "No contribution requests",
    noContributionRequestsDesc: "Requests will appear here once received",
    noContributions: "No contributions found",
    noContributionsDesc: "Start contributing to initiatives to see them here",
    showMore: "Show More",
    statusAccepted: "Accepted",
    statusRejected: "Rejected",
    // Password Reset
    forgotPasswordTitle: "Recover Password",
    forgotPasswordDesc: "Enter your email and we'll send you a verification code",
    sendOtp: "Send Code",
    otpSent: "Verification code sent to your email",
    backToLogin: "Back to Login",
    verifyOtpTitle: "Verify Code",
    verifyOtpDesc: "Enter the code sent to your email",
    otpLabel: "Verification Code",
    otpPlaceholder: "Enter 6-digit code",
    resendOtp: "Resend Code",
    resendOtpCooldown: "Resend in {seconds}s",
    verifyOtp: "Verify",
    resetPasswordTitle: "Set New Password",
    resetPasswordDesc: "Enter your new password",
    newPasswordLabel: "New Password",
    confirmPasswordLabel: "Confirm Password",
    resetPasswordBtn: "Set Password",
    passwordResetSuccess: "Password reset successfully. You can now log in.",
    // Notifications
    close: "Close",
    notificationsTitle: "Notifications",
    markAllRead: "Mark all as read",
    noNotifications: "No notifications",
    noNotificationsDesc: "Your notifications will appear here",
    notificationUnread: "Unread",
    // Initiatives Extra
    editInitiative: "Edit Initiative",
    deleteInitiative: "Delete Initiative",
    deleteInitiativeConfirmTitle: "Confirm Deletion",
    deleteInitiativeConfirmMsg: "Are you sure you want to delete this initiative? This action cannot be undone.",
    joinInitiative: "Join Initiative",
    joinBudgetLabel: "Budget Amount",
    joinBudgetPlaceholder: "Enter amount",
    joinSuccess: "Successfully joined the initiative",
    openInitiativesTab: "Open Initiatives",
    participatedTab: "Participated",
    myInitiativesTab: "My Initiatives",
    incomingTab: "Incoming",
    noOpenInitiatives: "No open initiatives available to join",
    noParticipated: "You haven't joined any initiatives yet",
    // Wallet Extra
    topUpWallet: "Top Up Wallet",
    topUpAmount: "Amount",
    topUpMethod: "Payment Method",
    topUpSuccess: "Wallet topped up successfully",
    // Analytics
    walkStatsTitle: "Walk Initiative Statistics",
    treeStatsTitle: "Tree Initiative Statistics",
    shopsStatsTitle: "Community Shops Statistics",
    saverStatsTitle: "Smart Saver Statistics",
    interestAnalyticsTitle: "Interest Analytics",
    totalSteps: "Total Steps",
    totalDistance: "Total Distance",
    avgSteps: "Avg. Steps",
    avgDistance: "Avg. Distance",
    highestSteps: "Highest Steps",
    totalTreesPlanted: "Total Trees Planted",
    goalTrees: "Goal Trees",
    avgTrees: "Avg. Trees",
    totalAmountSpent: "Total Amount Spent",
    goalAmount: "Goal Amount",
    totalPointsEarned: "Total Points Earned",
    totalSavings: "Total Savings",
    totalRewardsDistributed: "Total Rewards Distributed",
    progressPercentage: "Progress",
    totalInterested: "Total Interested",
    analyticsUnavailable: "Analytics unavailable for this initiative",
    // AI Translation
    autoTranslate: "Auto-translate to Arabic",
    translating: "Translating...",
    translationError: "Translation failed. You can type manually.",
    // Sidebar
    navWallet: "Wallet",
    navAnalytics: "Analytics",
    navContributions: "Contributions",
    // Walking Initiative Details
    walkingAreaType: "Walking Area Type",
    openExploration: "Open Exploration",
    structuredPath: "Structured Path",
    pathsCount: "Number of Paths",
    totalPathDistance: "Total Path Distance",
    locationsCount: "Number of Locations",
    noLocations: "No locations configured",
    noPaths: "No paths configured",
    locations: "Locations",
    paths: "Paths",
    segments: "Segments",
    meters: "m",
    participantLimit: "Participant Limit",
    goalSteps: "Goal (Steps)",
    rewardPerGoal: "Reward per Goal",
    goalTimeLimit: "Time Limit",
    months: "months",
    noTimeLimit: "No time limit",
    rewardHistory: "Reward History",
    goalsCompleted: "Goals Completed",
    greenPointsEarned: "Green Points Earned",
    progressToNextGoal: "Progress to Next Goal",
    stepsRemaining: "Steps Remaining",
    sidebarFaq: "FAQ",
    sidebarHowItWorks: "How it Works",
    sidebarTerms: "Terms & Conditions",
    // About page
    aboutHeroTitle: "About NCircle",
    aboutHeroSubtitle: "Building communities through meaningful impact",
    missionTitle: "Our Mission",
    missionBody: "Empowering organizations and communities to create measurable environmental and social impact.",
    visionTitle: "Our Vision",
    visionBody: "A world where every community has the tools to drive positive change.",
    valuesTitle: "Our Values",
    value1Title: "Impact",
    value1Body: "Every action counts toward a measurable goal.",
    value2Title: "Community",
    value2Body: "Initiatives are built with and for communities.",
    value3Title: "Transparency",
    value3Body: "Clear goals, measurable outcomes, open reporting.",
    aboutCtaTitle: "Ready to make an impact?",
    aboutCtaButton: "Get Started",
    // Public initiatives page
    publicInitiativesTitle: "Active Initiatives",
    publicInitiativesSubtitle: "Explore ongoing and upcoming community initiatives",
    initiativesComingSoon: "Initiatives Coming Soon",
    initiativesComingSoonBody: "We're preparing exciting new initiatives. Check back soon.",
    loginForFullAccess: "Want to participate?",
    loginForFullAccessBody: "Log in to join initiatives, track your impact, and earn rewards.",
    viewInitiativeDetails: "View Details",
    // Initiative account request form
    initiativeRequestTitle: "Request Initiative Account",
    initiativeRequestSubtitle: "Submit your details and our team will reach out to activate your account.",
    fullName: "Full Name",
    emailAddress: "Email Address",
    companyOrganisation: "Company / Organisation",
    phoneNumber: "Phone Number",
    submitRequest: "Submit Request",
    requestSentTitle: "Request Sent",
    requestSentBody: "Thank you. Our team will contact you shortly to complete account activation.",
    emailAlreadyUsed: "This email address has already been used for a request. Please use a different email.",
    optional: "(optional)",
    entityNameAr: "Entity Name (Arabic)",
    entityNameEn: "Entity Name (English)",
    entityType: "Entity Type",
    entityTypeSelectPlaceholder: "Select entity type",
    responsiblePerson: "Responsible Person Name",
    whatsappNumber: "Responsible Person WhatsApp",
    website: "Website",
    message: "Message",
    organizationLogo: "Organization Logo",
    uploadLogoText: "Upload your organization logo",
    acceptedFormats: "Accepted formats: JPEG, PNG",
    agreeToTerms: "I agree to the Terms & Conditions",
    agreeToTermsError: "You must agree to the terms to proceed",
    invalidFileType: "Invalid file type. Only JPEG and PNG are allowed",
    // 012-partner-wallet-ui
    periodDaily: "Daily",
    periodWeekly: "Weekly",
    periodMonthly: "Monthly",
    periodCustom: "Custom",
    periodFrom: "From",
    periodTo: "To",
    transactionVolume: "Transaction Volume",
    pointsEarned: "Points Earned",
    totalPoints: "Total Points",
    settlementRate: "Settlement Rate",
    commissionSummary: "Commission Summary",
    totalFeesPaid: "Total Fees Paid",
    totalCommissionEarned: "Total Commission Earned",
    commissionRate: "Commission Rate",
    netRevenue: "Net Revenue",
    topUpHistory: "Top-Up History",
    loadMore: "Load More",
    copyId: "Copy ID",
    copied: "Copied!",
    activityFeed: "Recent Activity",
    viewAll: "View All",
    initiativeImpact: "Initiative Impact",
    totalParticipants: "Total Participants",
    pointsDistributed: "Points Distributed",
    quickFilterAll: "All",
    quickFilterInbound: "Inbound",
    quickFilterOutbound: "Outbound",
    quickFilterSettled: "Settled",
    quickFilterPending: "Pending",
    quickFilterFailed: "Failed",
    exportCsv: "Export CSV",
    exportSelected: "Export Selected",
    noActivityYet: "No recent activity",
    estimatedFee: "Estimated fee",
    feeRate: "Fee rate",
    confirmTopUp: "Confirm Top-Up",
    topUpSummary: "Top-Up Summary",
    back: "Back",
    confirm: "Confirm",
    presetAmount: "Quick amount",
    topUpPending: "Your top-up request has been submitted and is awaiting admin approval.",
    sarEquivalent: "NC Equivalent",
    statusPendingMunicipalityApproval: "Pending Municipality Approval",
    statusMunicipalityApproved: "Municipality Approved",
    statusMunicipalityRejected: "Municipality Rejected",
    statusPendingAdminApproval: "Pending Admin Approval",
    statusAdminApproved: "Admin Approved",
    statusPlantingInProgress: "Planting in Progress",
    juthoorWizardStepTitle: "Configure Trees & Rewards",
    totalTrees: "Total Trees",
    rewardPerTree: "Reward per Tree",
    maxTreesPerClient: "Max Trees per Client",
    selectLand: "Select Land",
    treesPlanted: "Trees Planted",
    treesRewarded: "Trees Rewarded",
    treesSold: "Trees Sold",
    treesReserved: "Trees Reserved",
    treesAvailable: "Trees Available",
    totalRewardsCommitted: "Rewards Committed (GP)",
    rewardsEarned: "Rewards Earned (GP)",
    plantingProgress: "Planting Progress",
    participationLedger: "Participation Ledger",
    joinedDate: "Joined",
    ecosystemFlow: "Initiative Flow",
    activeLand: "Active Land",
    sustainableImpact: "Sustainable Impact",
    purchasePrice: "Purchase Price (NetZero)",
    sellingPrice: "Client Selling Price",
    marginPerTree: "Margin per Tree",
    atharProfitShare: "Athar Profit Share (%)",
    municipalityProfitShare: "Municipality Profit Share (%)",
    estimatedRevenue: "Estimated Total Revenue",
    totalPurchaseCost: "Total Purchase Cost",
    pendingApprovals: "Pending Approvals",
    profitLedger: "Profit Ledger",
    rejectionReason: "Rejection Reason",
    editAndResubmit: "Edit & Resubmit",
    submitForApproval: "Submit for Approval",
    approveInitiative: "Approve Initiative",
    rejectInitiative: "Reject Initiative",
    setPricing: "Set Pricing",
    juthoorAdminDashboard: "Juthoor Dashboard",
    netzeroPurchasedTrees: "Trees Purchased from NetZero",
    distributedProfit: "Distributed Profit",
    pendingProfit: "Pending Profit",
    pricingHistory: "Pricing History",
    enterRejectionReason: "Enter rejection reason",
    confirmApproval: "Confirm Approval",
    approvalConfirmText: "Are you sure you want to approve this initiative? A NetZero project will be created automatically.",
    totalClients: "Total Clients",
    totalRevenue: "Total Revenue",
    totalProfit: "Total Profit",
    atharProfit: "Athar Profit",
    municipalityProfit: "Municipality Profit"
  }
};

export function t(locale: Locale, key: MessageKey): string {
  return messages[locale][key];
}
